/**************************************************************************************************/
/*   File: /src/app/shared/models/local.document.id.ts                                            */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Thursday February 14th 2019                                                    */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The local document
 */
export class LocalDocumentId {
    /**
     * The id of uploaded document
     */
    id: string;
}